import { createContext, useRef, type ReactNode, type RefObject } from 'react';
import PortalDialog from '../../components/PortalDialog';
import textStyles from '../../../../stylesheets/components/text.module.scss';
import { usePortalAlertDialog } from '../PortalAlertContext';
import ProcessingOverlay from '../interaction_lock/ProcessingOverlay';
import { useTranslate } from '../Translations';

interface TenantPortalBodyProps {
  children: ReactNode;
}

interface TenantPortalBodyContext {
  tenantPortalBodyRef: RefObject<HTMLDivElement | null> | null;
}

export const TenantPortalBodyContext = createContext<TenantPortalBodyContext>({
  tenantPortalBodyRef: null,
});

export const TenantPortalBody = ({ children }: TenantPortalBodyProps) => {
  const tenantPortalBodyRef = useRef<HTMLDivElement>(null);
  const { alertDialogOpen, alertDialogMessage, closeAlert } =
    usePortalAlertDialog();
  const t = useTranslate();

  return (
    <div ref={tenantPortalBodyRef} className={textStyles.tenantPortal}>
      <TenantPortalBodyContext.Provider
        value={{
          tenantPortalBodyRef: tenantPortalBodyRef,
        }}
      >
        <>
          {children}
          {alertDialogOpen && (
            <PortalDialog
              dialogId="alert-dialog"
              title={t('Error')}
              submitText={t('Close')}
              acceptFunction={closeAlert}
            >
              <div className="alert-dialog-message">{alertDialogMessage}</div>
            </PortalDialog>
          )}
          <ProcessingOverlay tenantPortalBodyRef={tenantPortalBodyRef} />
        </>
      </TenantPortalBodyContext.Provider>
    </div>
  );
};
